<template>
	<div>
		<div class="ts-relative ts-flex ts-w-full ts-flex-wrap ts-items-stretch">
			<input v-model="search_value" type="text" ref="input_text"
				:placeholder="$t('sparePartReplacement.serialNumber')" @keypress.enter="onEnter"
				class="ts-px-3 ts-py-3 ts-placeholder-blueGray-300 ts-text-blueGray-600 ts-relative ts-border ts-border-gray-300 ts-bg-white ts-rounded ts-text-sm ts-border-1 ts-shadow ts-outline-none focus:ts-outline-none focus:ts-ring ts-w-full ts-pr-10" />
			<span
				class=" hover:ts-text-blue-600 ts-cursor-pointer ts-z-10 ts-h-full ts-leading-snug ts-font-normal ts-absolute ts-text-center ts-text-blueGray-300 ts-bg-transparent ts-rounded ts-text-base ts-items-center ts-justify-center ts-w-8 ts-right-0 ts-pr-3 ts-py-3"
				@click.prevent="onEnter">
				<i class="fas fa-search ts-z-[7]" v-if="!loading"></i>
				<i class="fas fa-spinner d-inline-block spin" v-else></i>
			</span>
		</div>
		<div class="ts-h-32 ts-border ts-border-blue-300 ts-mt-3 ts-rounded ts-overflow-y-scroll ts-p-3">
			<ts-loading-banner :loading="loading">
				<table class="ts-w-full">
					<thead>
						<tr>
							<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
								{{ $t('sparePartReplacement.category') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
								{{ $t('sparePartReplacement.productGroup') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
								{{ $t('sparePartReplacement.barcode') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
								{{ $t('sparePartReplacement.productNameEn') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
								{{ $t('sparePartReplacement.serialNumber') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
								{{ $t('sparePartReplacement.vin') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3">
								{{ $t('sparePartReplacement.engineNumber') }}
							</th>
							<th class="ts-uppercase ts-bg-gray-200 ts-py-1 ts-px-3 ts-text-center">
								{{ $t('sparePartReplacement.grade') }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-if="mainProduct.length == 0">
							<td colspan="7" class="ts-text-center ts-p-3 ts-space-x-1">
								<i class="fa fa-folder-open ts-text-gray-200"></i>
								<label class="ts-text-gray-400">
									{{ $t('noData') }}
								</label>
							</td>
						</tr>
						<tr v-else>
							<td class="ts-py-1 ts-px-3">
								{{ mainProduct.category_name_en }}
							</td>
							<td class="ts-py-1 ts-px-3">
								{{ mainProduct.pro_group_name_en }}
							</td>
							<td class="ts-py-1 ts-px-3">
								{{ mainProduct.barcode }}
							</td>
							<td class="ts-py-1 ts-px-3">
								{{ mainProduct.product_name_en }}
							</td>
							<td class="ts-py-1 ts-px-3">
								{{ mainProduct.serial_no }}
							</td>
							<td class="ts-py-1 ts-px-3">
								{{ mainProduct.original_serial }}
							</td>
							<td class="ts-py-1 ts-px-3">
								{{ mainProduct.engine_number }}
							</td>
							<td class="ts-py-1 ts-px-3 ts-text-center">
								{{ mainProduct.product_grade }}
							</td>
						</tr>
					</tbody>
				</table>
			</ts-loading-banner>
		</div>
	</div>
</template>
<script>
import { Errors } from 'form-backend-validation';
import { mapActions, mapState } from 'vuex';

export default {
	props: ['value', 'validate'],
	data() {
		return {
			errors: new Errors(),
			loading: false,
			search_value: '',
			model: {}
		}
	},
	mounted() {
		this.$refs.input_text.focus();
	},
	created() {
		this.model = this.value
	},
	computed: {
		...mapState('wholesale/v2/replacement', ['formViewDatas']),
		mainProduct() {
			if (this.formViewDatas['mainProduct']) {
				return this.formViewDatas['mainProduct']
			}
			return []
		}
	},
	methods: {
		...mapActions('wholesale/v2/replacement', ['getFormViewModel']),
		async onEnter() {
			this.loading = true
			await this.getFormViewModel({
				index: 'mainProduct',
				params: {
					fnName: 'mainProduct',
					search_value: this.search_value
				}
			})
				.then((response) => {
					let main_product = response.data.mainProduct

					this.model.product_id = main_product.product_id
					this.model.product_grade = main_product.product_grade
					this.model.uom_id = main_product.uom_id
					this.model.serial_no = main_product.serial_no
				})
				.finally(() => {
					this.loading = false
				})
		}
	},

	watch: {
		validate: function (error) {
			this.errors = new Errors(error.errors)
		}
	}
}
</script>